import { contactInfo } from '@/mocks/home';

export default function Contact() {
  return (
    <section id="contact" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
          投稿与合作
        </h2>
        <p className="text-sm text-foreground-600 mb-6 md:mb-8">{contactInfo.desc}</p>
        <div className="bg-background-50 rounded-lg p-5 md:p-8 border border-background-200/70 max-w-xl">
          <div className="flex flex-col sm:flex-row gap-4 md:gap-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0">
                <i className="ri-mail-line text-primary-600 text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500">电子邮箱</p>
                <p className="text-sm font-medium text-foreground-800">{contactInfo.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center shrink-0">
                <i className="ri-qq-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <p className="text-xs text-foreground-500">QQ 交流群</p>
                <p className="text-sm font-medium text-foreground-800">{contactInfo.qq}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}